import { useEffect, useRef } from 'react';

const THROTTLE = 200;

function setVhStyleProperty(onDone?: () => void) {
  const documentRoot = document.querySelector<HTMLElement>(':root');
  const vh = window.innerHeight * 0.01;

  if (documentRoot) {
    documentRoot.style.setProperty('--vh', `${vh}px`);
  }

  if (onDone) {
    onDone();
  }
}

export function useViewportHeight() {
  const timer = useRef<number | null>(null);

  useEffect(() => {
    setVhStyleProperty();

    const eventCallback = () => {
      if (!timer.current) {
        timer.current = window.setTimeout(
          () =>
            setVhStyleProperty(() => {
              timer.current = null;
            }),
          THROTTLE
        );
      }
    };

    window.addEventListener('resize', eventCallback);
    window.addEventListener('orientationchange', eventCallback);

    return () => {
      if (timer.current) {
        window.clearTimeout(timer.current);
      }

      window.removeEventListener('resize', eventCallback);
      window.removeEventListener('orientationchange', eventCallback);
    };
  }, []);
}
